import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { useI18n } from '@hydra/common/components/i18n';
import Label from '@hydra/common/components/Label';
import Grid from '@material-ui/core/Grid';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';
import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';

const assetTags = {
  js: 'crawler_js',
  css: 'crawler_css',
  img: 'crawler_img',
  pdf: 'crawler_pdf'
};

export function HttpWithinHttpsRow (props) {
  const { translate } = useI18n();
  function translatedAssetTypes (assets) {
    return assets.reduce(
      (issueList, issue) => {
        if (assetTags[issue]) {
          issueList.push(translate(assetTags[issue]));
        }
        return issueList;
      },
      []
    );
  }

  const {
    columnStyles,
    issue,
    className: classNameProp
  } = props;

  const domain = get(props, ['relay', 'route', 'params', 'url'], '');
  const sourceUrl = new DCUrl(domain, issue.source_url);
  const assetUrls = issue.asset_urls.map(url => new DCUrl(domain, url));

  return (
    <Grid container className={classNameProp} alignItems='flex-start'>
      <Grid item {...columnStyles[0]}>
        <Label style={parseSeverity(issue.severity)} noBackground>
          <strong>
            {issue.asset_count}
          </strong>
        </Label>
      </Grid>
      <Grid item {...columnStyles[1]}>
        <List items={translatedAssetTypes(issue.asset_types)} />
      </Grid>
      <Grid item {...columnStyles[2]}>
        <List items={assetUrls} />
      </Grid>
      <Grid item {...columnStyles[3]}>
        <List items={sourceUrl} />
      </Grid>
    </Grid>
  );
}

HttpWithinHttpsRow.propTypes = {
  issue: PropTypes.object,
  columnStyles: PropTypes.array,
  relay: PropTypes.object
};

export default createFragmentContainer(HttpWithinHttpsRow, {
  issue: graphql`
    fragment HttpWithinHttpsRow_issue on HttpInHttps {
      id
      type
      severity
      asset_count
      asset_types
      asset_urls
      source_url
    }
  `
});
